import type { Area, Link } from 'src/data';
import type { RootState } from '../../app/store';

export const selectAreasList = (state: RootState) => state.contentful.areasList;

export const getSelectPoint = (id: string) => (state: RootState) => state.contentful.points[id];

export const getSelectArea = (id: string) => (state: RootState) => state.contentful.areas[id];

export const getSelectAsset = (id: string) => (state: RootState) => state.contentful.assets[id];

export const selectCredits = (state: RootState) => state.contentful.settings.fields.credits;

export const getIdOfAreaIndex = (areaIndex: number, state: RootState) => {
  const area = state.contentful.areasList[areaIndex];
  if (!area) return null;

  return area.sys.id;
};

export const getIndexOfArea = (areaId: string, state: RootState) => {
  return state.contentful.areasList.findIndex(
    (area: Area) => area.sys.id === areaId
  );
};

export const getIdOfPointIndex = (areaId: string, pointIndex: number, state: RootState) => {
  const area = getSelectArea(areaId)(state);
  if (!area || !area.fields.points) return null;

  const points = area.fields.points['en-US'];

  let index = pointIndex;
  if (pointIndex > points.length) index = -1;
  if (pointIndex < -1) index = points.length - 1;

  const point = area.fields.points['en-US'][index];
  if (!point) return null;

  return point.sys.id;
};

export const getIndexOfPoint = (areaId: string, pointId: string, state: RootState) => {
  const area = getSelectArea(areaId)(state);
  if (!area) return -1;

  return area.fields.points['en-US'].findIndex(
    (link: Link) => {
      return link.sys.id === pointId;
    }
  );
};

export const selectNumberOfAreas = (state: RootState) => {
  return state.contentful.areasList.length;
}

export const selectIsFirstArea = (state: RootState) => {
  const currentAreaId = state.navigation.currentAreaId;
  const firstArea = state.contentful.areasList[state.contentful.areasList.length - 1];
  return firstArea.sys.id === currentAreaId;
}

export const selectIsLastArea = (state: RootState) => {
  const currentAreaId = state.navigation.currentAreaId;
  const lastArea = state.contentful.areasList[0];
  return lastArea.sys.id === currentAreaId;
}
